import React, { Component } from "react";
import { message, Tag } from "antd";
import axios from "axios";
import moment from "moment";
import { connect } from "react-redux";
import { ModalItem, ButtonItem, DatePickerItem, MensajeError } from "../../../../../Components/Items";
import { formatearFechaHora, formatearTiempo } from "./planeacion.utils";
import ModalAjustarInicioRealPU from "./ModalAjustarInicioRealPU";

const TOLERANCIA_MIN = 5;
const PORCENTAJE_AMARILLO = 0.15;

export const SEMAFORO = {
  verde: { color: "#52c41a", paleta: "verde", texto: "A tiempo" },
  amarillo: { color: "#faad14", paleta: "amarillo", texto: "Desfase leve" },
  rojo: { color: "#ff4d4f", paleta: "rojo", texto: "Desfasada" },
};

export const semaforoDe = (orden) => {
  const retraso = orden?.retrasoMin || 0;
  if (retraso <= TOLERANCIA_MIN) return "verde";
  const limiteAmarillo = Math.max(TOLERANCIA_MIN, (orden?.duracionEstimadaMin || 0) * PORCENTAJE_AMARILLO);
  return retraso <= limiteAmarillo ? "amarillo" : "rojo";
};

class ModalHorarioOrdenPU extends Component {
  state = { loading: false, fechaInicio: null, ajusteVisible: false };

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible) {
      const inicio = this.props.orden?.planeado?.inicio;
      this.setState({ loading: false, fechaInicio: inicio ? moment(inicio) : null, ajusteVisible: false });
    }
  }

  reprogramar = () => {
    if (!this.state.fechaInicio) {
      MensajeError({ message: "Elige la nueva fecha y hora de inicio" });
      return;
    }
    this.setState({ loading: true });
    axios
      .post(
        "ordenesDeProduccionPU/editarOrden",
        { empresaId: this.props.empresaId, ordenId: this.props.orden._id, fechaInicio: this.state.fechaInicio.toDate() },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Hora de inicio reprogramada");
          this.props.onGuardado();
        } else {
          MensajeError({ message: res.data.error || "No se pudo reprogramar la orden" });
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        MensajeError({ message: "Error al conectar con el servidor" });
      });
  };

  renderEstado() {
    const { orden, unidadTiempoProduccion } = this.props;
    const semaforo = SEMAFORO[semaforoDe(orden)];
    const retraso = orden.retrasoMin || 0;
    const detalle =
      retraso > TOLERANCIA_MIN
        ? `Retraso de ${formatearTiempo(retraso, unidadTiempoProduccion)}`
        : retraso < -TOLERANCIA_MIN
        ? `Adelanto de ${formatearTiempo(-retraso, unidadTiempoProduccion)}`
        : "Dentro de la tolerancia";
    return (
      <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "10px 14px", borderRadius: 8, background: "#fafafa", marginBottom: 16 }}>
        <span style={{ width: 14, height: 14, borderRadius: "50%", background: semaforo.color, display: "inline-block" }} />
        <b>{semaforo.texto}</b>
        <span style={{ color: "#8c8c8c" }}>{detalle}</span>
      </div>
    );
  }

  render() {
    const { visible, onCerrar, orden, permisoEditar, unidadTiempoProduccion } = this.props;
    if (!orden) return null;
    const yaInicio = !!orden.avance?.inicioReal;
    const atrasada = (orden.retrasoMin || 0) > TOLERANCIA_MIN;
    const puedeEditar = permisoEditar && !orden.terminada;

    return (
      <>
        <ModalItem title={`Horario ${orden.folio}`} visible={visible} spinning={this.state.loading} onCancel={onCerrar} width="40%" paddingTop footer={null}>
          {this.renderEstado()}

          <div style={{ marginBottom: 6 }}>
            <span style={{ color: "#8c8c8c" }}>Plan: </span>
            {formatearFechaHora(orden.planeado?.inicio)} → {formatearFechaHora(orden.planeado?.fin)}
          </div>
          <div style={{ marginBottom: 6, color: atrasada ? "#ff4d4f" : "#389e0d" }}>
            <span style={{ color: "#8c8c8c" }}>{orden.terminada || yaInicio ? "Real: " : "Proyectado: "}</span>
            {formatearFechaHora(orden.proyectado?.inicio)} → {formatearFechaHora(orden.proyectado?.fin)}
            {orden.avance?.inicioAjustado && (
              <Tag color="blue" style={{ marginLeft: 6 }}>
                ajustado
              </Tag>
            )}
          </div>
          {orden.avance?.inicioAjustado && (
            <div style={{ color: "#8c8c8c", fontSize: 12, marginBottom: 6 }}>
              Ajustado por {orden.avance.inicioAjustado.usuarioNombre || "—"}
              {orden.avance.inicioAjustado.motivo ? `: ${orden.avance.inicioAjustado.motivo}` : ""} (automático: {formatearFechaHora(orden.avance.inicioRealAutomatico)})
            </div>
          )}
          <div style={{ color: "#8c8c8c", fontSize: 12 }}>Duración estimada: {formatearTiempo(orden.duracionEstimadaMin || 0, unidadTiempoProduccion)}</div>
          {!(orden.duracionEstimadaMin > 0) && <div style={{ color: "#faad14", marginTop: 6 }}>Sin tiempo ciclo en sus matrices</div>}

          {puedeEditar && !yaInicio && (
            <div style={{ marginTop: 20 }}>
              <div style={{ fontWeight: 600, marginBottom: 4 }}>Reprogramar hora de inicio</div>
              <div style={{ display: "flex", gap: 8 }}>
                <DatePickerItem
                  style={{ flex: 1 }}
                  allowClear={false}
                  showTime={{ format: "HH:mm", minuteStep: 5 }}
                  format="DD/MM/YYYY HH:mm"
                  inputReadOnly
                  value={this.state.fechaInicio}
                  onSelect={(fechaInicio) => this.setState({ fechaInicio })}
                  onChange={(fechaInicio) => fechaInicio && this.setState({ fechaInicio })}
                />
                <ButtonItem type="primary" onClick={this.reprogramar}>
                  Guardar
                </ButtonItem>
              </div>
            </div>
          )}
          {puedeEditar && yaInicio && (
            <div style={{ marginTop: 20, display: "flex", justifyContent: "flex-end" }}>
              <ButtonItem type="primary" onClick={() => this.setState({ ajusteVisible: true })}>
                Ajustar inicio real
              </ButtonItem>
            </div>
          )}
        </ModalItem>
        <ModalAjustarInicioRealPU
          visible={this.state.ajusteVisible}
          ordenId={orden._id}
          folio={orden.folio}
          inicioAjustado={orden.avance?.inicioAjustado}
          inicioRealAutomatico={orden.avance?.inicioRealAutomatico}
          onCerrar={() => this.setState({ ajusteVisible: false })}
          onGuardado={() => {
            this.setState({ ajusteVisible: false });
            this.props.onGuardado();
          }}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
  unidadTiempoProduccion: state.empresa.unidadTiempoProduccion,
});

export default connect(mapStateToProps)(ModalHorarioOrdenPU);
